/* istanbul ignore file */
export default {
  inappropriateContentType: {
    type: 'enum',
    required: true,
  },
};
